import './popup.css';
const getWindowSpecs = (invisible) => {
    const width = invisible ? 1 : 0.6 * window.outerWidth;
    const left = invisible ? 1 : 0.2 * window.outerWidth;
    const height = invisible ? 1 : 0.6 * window.outerHeight;
    const top = invisible ? 1 : 0.2 * window.outerHeight;
    return {
        height,
        left,
        status: 0,
        titlebar: 0,
        top,
        width
    };
};
const getLoadingElement = (message) => {
    const container = document.createElement('div');
    container.classList.add('window-loader');
    container.id = 'window-loader';
    const msg = document.createElement('div');
    msg.classList.add('window-loader-message');
    msg.innerHTML = message;
    container.appendChild(msg);
    return container;
};
export default class Popup {
    constructor(params) {
        this.message = 'Please wait...';
        this.target = 'Ratting';
        this.invisible = false;
        this.url = 'about:blank';
        this.onClose = () => undefined;
        if (params) {
            if (typeof params.invisible !== 'undefined') {
                this.invisible = params.invisible;
            }
            if (typeof params.target !== 'undefined') {
                this.target = params.target;
            }
            if (typeof params.url !== 'undefined') {
                this.url = params.url;
            }
            if (typeof params.message !== 'undefined') {
                this.message = params.message;
            }
        }
    }
    open(url, message, invisible) {
        if (typeof url !== 'undefined' && url !== null) {
            this.url = url;
        }
        if (typeof invisible !== 'undefined' && invisible !== null) {
            this.invisible = invisible;
        }
        if (typeof message !== 'undefined' && message !== null) {
            this.message = message;
        }
        const specs = getWindowSpecs(this.invisible);
        const specsString = `width=${specs.width},height=${specs.height},left=${specs.left},top=${specs.top},status=${specs.status},titlebar=${specs.titlebar}`;
        this.popup = window.open(this.url || 'about:blank', this.target, specsString);
        this.popup.moveTo(specs.left, specs.top);
        this.popup.resizeTo(specs.width, specs.height);
        this.callback();
        return this.popup;
    }
    callback() {
        this.setLoading();
        this.timer = setInterval(() => {
            if (!this.popup || this.popup.closed) {
                clearInterval(this.timer);
                this.clearLoading();
                this.onClose();
            }
        }, 500);
    }
    setLoading() {
        let el = document.getElementById('window-loader');
        if (!el) {
            el = getLoadingElement(this.message);
            document.body.appendChild(el);
        }
        setTimeout(() => {
            if (el) {
                el.classList.add('window-loader-visible');
            }
        }, 10);
    }
    clearLoading() {
        const el = document.getElementById('window-loader');
        if (el) {
            el.classList.remove('window-loader-visible');
            setTimeout(() => {
                if (el) {
                    el.remove();
                }
            }, 150);
        }
    }
}
;
//# sourceMappingURL=data:application/json;base64,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